import React from "react";

import {
  ArrowIcon,
  CircleIcon,
  DisplayDiv,
  DisplayTextDiv,
  LucideIconWrapper,
  MenuItem,
  MenuLabel,
  MenuLink,
  Ul,
} from "app/NavBar/index.style";

function NavDropdownItem({ item, isActive, isOpen, isChildActive, onToggle }) {
  const LucideIcon = item.lucideIcon;

  return (
    <MenuItem $top={item.topOffset ?? 10}>
      <DisplayDiv onClick={onToggle}>
        <DisplayTextDiv>
          {LucideIcon && (
            <LucideIconWrapper $active={isActive}>
              <LucideIcon size={24} strokeWidth={2.1} />
            </LucideIconWrapper>
          )}
          <MenuLabel>{item.label}</MenuLabel>
        </DisplayTextDiv>
        <ArrowIcon $open={isOpen} size={20} />
      </DisplayDiv>
      {isOpen && (
        <Ul>
          {item.children.map((child) => {
            const activeChild = isChildActive(child.to);

            return (
              <li key={child.key}>
                <MenuLink to={child.to} $active={activeChild}>
                  <CircleIcon $active={activeChild} />
                  {child.label}
                </MenuLink>
              </li>
            );
          })}
        </Ul>
      )}
    </MenuItem>
  );
}

export default NavDropdownItem;
